
const { ccclass, property } = cc._decorator;
import ViewBase from "../../../table/module/poker_table/poker_table_seat_base_view"
import Utility from "../../../../utility/utility";
import GameUtil from "../../../../utility/game_util";

@ccclass
export default class BiPaiTableSeatView extends ViewBase {

    
    @property(cc.Node)
    nodeIntrusting: cc.Node = null
    
    @property(cc.Node)
    nodeRecharge: cc.Node = null

    @property(cc.Node)
    nodeBubble: cc.Node = null

    @property(cc.Label)
    labelBubble: cc.Label = null

    @property(cc.Node)
    nodeGoldParent: cc.Node = null

    @property(cc.Float)
    maxGoldPosRadius: number = 0
    
    @property(cc.Node)
    nodeWinEffect: cc.Node = null

    @property(cc.Node)
    nodePiaoFenAnim: cc.Node = null

    @property(cc.Label)
    labelWinPiaoFen: cc.Label = null

    @property(cc.Label)
    labelLosePiaoFen: cc.Label = null

    @property(cc.Node)
    nodeGoldAnim: cc.Node = null

    @property(cc.Node)
    nodeBankerAnim: cc.Node = null

    @property(cc.Node)
    nodeWatch: cc.Node = null

    protected m_fk_node: cc.Node = null
    protected m_fk_label: cc.Label = null

    reset(){
        super.reset()
        this.showNoSeatDown(false)
    }

    getSeatStyleName(index: number):string{
        switch (index) {
            case 0:
                return 'Bottom'
            case 1:
            case 2:
                return 'Left'
            case 3:
            case 4:
                return 'Right'
        
            default:
                break;
        }
        return ''
    }

    
    showIntrustedTag(show: boolean){
        this.nodeIntrusting.active = show
    }

    showRechargeTag(show: boolean){
        this.nodeRecharge.active = show
    }

    showBubble(show: boolean, text?: string){
        this.nodeBubble.active = show
        if(show){
            this.labelBubble.string = text
        }        
    }

    setFkNodeAndLabel(node: cc.Node, label: cc.Label){
        this.m_fk_node = node
        this.m_fk_label = label
    }

    showFk(show: boolean, fkNum: number){
        this.m_fk_node && (this.m_fk_node.active = !!show)
        if(show){
            this.m_fk_label && (this.m_fk_label.string = Utility.filterPlayerGoldNum(fkNum))
        }
    }

    showWinEffect(show: boolean, onFinish?: Function){
        this.nodeWinEffect.active = !!show
        this.scheduleOnce(function(){
            onFinish && onFinish()
        }, 0.8)
    }

    showPiaoFenAnim(show: boolean, score?: number, onFinish?: Function){
        let self = this
        this.nodePiaoFenAnim.active = !!show
        if(show){
            let text = (score >= 0 ? '+': '') + GameUtil.currencyFormatting(score)
            score >= 0 && (this.labelWinPiaoFen.string = text)
            score < 0 && (this.labelLosePiaoFen.string = text)
            this.labelWinPiaoFen.node.active = score >= 0
            this.labelLosePiaoFen.node.active = score < 0
            this.scheduleOnce(function(){
                self.nodePiaoFenAnim.active = false
                onFinish && onFinish()
            }, 1.333)
        }
    }

    showGoldAnim(show: boolean, delay?: number, onFinish?: Function){
        let self = this        
        if(show){
            let deal_fun = function(){
                let node = cc.instantiate(self.nodeGoldAnim)
                node.parent = self.nodeGoldAnim.parent
                node.position = self.nodeGoldAnim.position
                node.active = true
                self.scheduleOnce(function(){
                    node.active = false
                    node.destroy()
                    onFinish && onFinish()
                }, 1)
            }
            if(delay){
                self.scheduleOnce(function(){
                    deal_fun()
                }, delay)
            }else{
                deal_fun()
            }
        }
    }

    showBankerTag(show: boolean){
        super.showBankerTag(show)
        if(!show){
            this.nodeBankerAnim.active = false
        }
    }

    playSetBankerAnim(onFinish?: Function){
        let self = this        
        super.showBankerTag(false)
        this.nodeBankerAnim.active = true
        self.scheduleOnce(function(){
            self.nodeBankerAnim.active = false
            self.showBankerTag(true)
            onFinish && onFinish()
        }, 0.5)
    }

    setClickNotSeatBtnListener(callback: Function){
    }

    showWatchTag(show: boolean){
        this.nodeWatch.active = !!show
    }
}
